import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RegisterShared {
  constructor() {}
  private _gender: string;
  private _birthdate: Date;
  private _weight: number;
  private _height: number;
  private _name: string;
  private _referrer: string;
  private _expireDate: Date;

  public get expireDate(): Date {
    return this._expireDate;
  }
  public set expireDate(value: Date) {
    this._expireDate = value;
  }
  public get referrer(): string {
    return this._referrer;
  }
  public set referrer(value: string) {
    this._referrer = value;
  }
  public get gender(): string {
    return this._gender;
  }
  public set gender(value: string) {
    this._gender = value;
  }
  public get birthdate(): Date {
    return this._birthdate;
  }
  public set birthdate(value: Date) {
    this._birthdate = value;
  }
  public get weight(): number {
    return this._weight;
  }
  public set weight(value: number) {
    this._weight = value;
  }
  public get height(): number {
    return this._height;
  }
  public set height(value: number) {
    this._height = value;
  }
  public get name(): string {
    return this._name;
  }
  public set name(value: string) {
    this._name = value;
  }

  private registerActivateButtonObs = new BehaviorSubject<number>(-1);
  registerActivateButtonObs$ = this.registerActivateButtonObs.asObservable();

  private registerDeactivateButtonObs = new BehaviorSubject<number>(-1);
  registerDeactivateButtonObs$ =
    this.registerDeactivateButtonObs.asObservable();

  private nextPageObs = new BehaviorSubject<boolean>(false);
  nextPageObs$ = this.nextPageObs.asObservable();

  registerActivateButton(id: number) {
    this.registerActivateButtonObs.next(id);
    this.registerActivateButtonObs.next(-1);
  }

  registerDeactivateButton(id: number) {
    this.registerDeactivateButtonObs.next(id);
    this.registerDeactivateButtonObs.next(-1);
  }

  nextPage() {
    this.nextPageObs.next(true);
    this.nextPageObs.next(false);
  }
}
